export const GET_ALL_BEDS_PATIENTS_ENDPOINT =
  'api/ipd/bed-patient-assignments/getAllBedAndPatientsByStatusAndLocation'
export const GET_ASSIGNED_PATIENTS_FOR_A_BED_ENDPOINT =
  'api/ipd/bed-patient-assignments/getAssignedPatientForABed?bedStatus='
export const ALL_NOTIFICATIONS_STATUS =
  'api/ipd/notificationstatus/getAllNotifications'
export const ODOOCOGNITIVECARE_URL = '/api/v1/download_invoice_template'
export const ODOOCOGNITIVECARE_INVOICE_URL = '/odoo/invoicing'
export const SEND_WHATSAPP_MESSAGE = '/ipd/notification/sendNotification'
export const DMS_UPLOAD_AND_SEND_NOTIFICATION = '/ipd/notification/upload-file'
export const radiologySearchEndpoint = 'api/ipd/radiology/radiologyOrdersSearch'

export const GET_OPD_DIAGNOSIS_ENDPOINT =
  'api/thopopdservice/v1/opd/getDiagnosis?encounterId='
export const POST_OPD_DIAGNOSIS_ENDPOINT =
  'api/thopopdservice/v1/opd/saveDiagnosis'
export const GET_OPD_SYSTEMIC_ENDPOINT =
  'api/thopopdservice/v1/opd/getSystemicExamination?encounterId='
export const POST_OPD_SYSTEMIC_ENDPOINT =
  'api/thopopdservice/v1/opd/saveSystemicExamination'
export const GET_OPD_HISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/getHistoryAndExamination?encounterId='
export const POST_OPD_HISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/saveHistoryAndExamination'
export const GET_OPD_VITALS_ENDPOINT =
  'api/thopopdservice/v1/opd/getVitals?encounterId='
export const POST_OPD_VITALS_ENDPOINT = 'api/thopopdservice/v1/opd/saveVitals'
export const GET_OPD_TREATMENTPLAN_ENDPOINT =
  'api/thopopdservice/v1/opd/getTreatmentPlan?encounterId='
export const POST_OPD_TREATMENTPLAN_ENDPOINT =
  'api/thopopdservice/v1/opd/saveTreatmentPlan'
export const GET_OPD_PAINHISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/getPainHistory?encounterId='
export const POST_OPD_PAINHISTORY_ENDPOINT =
  'api/thopopdservice/v1/opd/savePainHistory'
export const GET_OPD_OBJECTIVE_ENDPOINT =
  'api/thopopdservice/v1/opd/getObjective?encounterId='
export const POST_OPD_OBJECTIVE_ENDPOINT =
  'api/thopopdservice/v1/opd/saveObjective'

export const GET_DOCTORS_ENDPOINT = 'api/doctor-app/v1/doctors'

export const DEVICE_VITALS_POST = 'api/ipd/vital-info/vitals'
export const DEVICE_VITALS_GET = 'api/ipd/vital-info/vitals?encounterId='
export const GET_DEVICE_RING_VITALS = 'api/ipd/jc-ring/v2/latest/'
export const GET_DEVICE_RING = 'api/ipd/jc-ring/'

export const GET_ALL_ROLES = '/ayuvubharosa/portal/users/getAllRoles'
export const GET_PREMIUM_PRODUCTS = '/api/products/list'
export const GET_PREMIUM_AGE_BAND = '/api/pricelist/age_band'
export const GET_PREMIUM_PRICE_LIST = '/api/product/pricelist'

export const GET_MEMBERSHIP_BENIFITS = '/membership/benefits?line_id='
export const GET_MEMBERSHIP_PLAN_AND_PATIENT_DETAILS =
  '/membership/line?line_id='

export const UPLOAD_CANCER_SCREENING = 'api/cancer-screening/upload'
export const SUMIT_CANCER_SCREENING = 'api/cancer-screening/submit'
export const SUMIT_CANCER_SCREENING_DV = 'api/cancer-screening/submit-final'
export const GET_CANCER_SCREENING_OBSERVATION =
  'api/cancer-screening/observations?encounterId='
export const GET_CANCER_FILE = 'api/cancer-screening/download/'

export const DELETE_DMS_DOCUMENT = '/dms/v1/documents?id='
export const DOWNLOAD_DMS_DOCUMENT = '/dms/v1/documents/download?id='
export const GET_DMS_DOCUMENT = '/dms/v1/documents/download?id='

export const HOMEKARE_GET = 'api/ipd/homekare/wildcard-patient-info?'
export const HOMEKARE_PATCH = 'api/ipd/homekare/status/'

export const SAVE_COMPOSITION = 'api/ipd/initial-assessment/composition'
export const GENERAL_INITIAL_OBSERVATION =
  'api/ipd/initial-assessment/general-initial-observation'
export const BREATHING_OBSERVATION =
  'api/ipd/initial-assessment/breathing-initial-observation'
export const GCS_OBSERVATION = 'api/ipd/initial-assessment/gcs'
export const GENERAL_EXAMINATION_OBSERVATION =
  'api/ipd/initial-assessment/general-examination-observation'
export const GET_COMPOSITION = 'api/ipd/initial-assessment/composition'

// asha worker
export const GET_REGISTRATION_DETAILS = 'api/cancer-screening/getPatients'
export const GET_VISITS_DETAILS = 'api/cancer-screening/getAppointments'
export const QUICK_REGISTRATION = 'api/cancer-screening/registration'
export const CANCER_ASSESSMENT_FORM = 'api/cancer-screening/assessment'
export const CONSENT_FORM_UPLOAD = 'api/cancer-screening/consent'
export const GET_CANCER_ASSESSMENT =
  'api/cancer-screening/assessment/latest?muhId='
export const GET_UPLOAD_CONSENT = 'api/cancer-screening/consent/latest?muhId='

export const GET_CANCER_SCREENING_VISITS =
  'api/cancer-screening/getAppointments'
// asha worker

export const GET_DOCUMENT_ID_HASURA_ENDPOINT =
  'api/api/rest/getDocumentIdsForVisitIds'
export const GET_DOCUMENT_BY_ID_DMS_ENDPOINT =
  'api/dms/v1/documents/download?id='
